import { feedUpdates } from "@/mocks/hotTopics";

export default function UpdateFeed() {
  return (
    <section id="feed" className="bg-background-100/50">
      <div className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              LIVE · 实时热议短讯流
            </p>
            <h4 className="flex items-center gap-3 font-serif text-2xl font-black text-foreground-950 md:text-3xl">
              <a href="#feed" className="flex items-center gap-3">
                短讯刷屏，紧跟新动态
              </a>
            </h4>
          </div>
          <p className="flex items-center gap-2 text-sm text-foreground-500">
            <span className="h-2 w-2 rounded-full bg-primary-500 animate-pulse-dot" />
            每分钟都在更新的讨论动态
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
          <ul className="divide-y divide-background-200">
            {feedUpdates.map((u) => (
              <li key={u.title} className="group-card grid gap-3 px-4 py-4 md:grid-cols-[100px_1fr_auto] md:items-center md:px-6">
                <span className="flex items-center gap-1.5 text-xs font-semibold text-accent-700 md:justify-start">
                  <i className="ri-time-line text-sm" />
                  {u.time}
                </span>

                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <p className="text-[15px] font-semibold leading-snug text-foreground-900">{u.title}</p>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                      {u.zone}
                    </span>
                  </div>
                  <p className="mt-1.5 line-clamp-2 max-w-3xl text-xs leading-relaxed text-foreground-500 md:text-sm">
                    {u.digest}
                  </p>
                </div>

                <span className="flex items-center justify-end gap-1 whitespace-nowrap text-xs text-foreground-500">
                  <i className="ri-eye-line text-primary-500" />
                  新增 {u.heat}万围观
                </span>
              </li>
            ))}
          </ul>
        </div>

        <a
          href="#feed"
          className="mx-auto mt-5 flex h-10 w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 md:w-auto md:px-8"
        >
          <i className="ri-loader-4-line" />
          加载更多热议短讯
        </a>
      </div>
    </section>
  );
}